// extracted by mini-css-extract-plugin
module.exports = {"row":"StaticListItem-module__row__3FCFy","link":"StaticListItem-module__link__18Q6z"};